import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseComponent, ApplicationService } from '@pit/core';
import { IDtoUser } from '@pit/frontend-model';
import { IPinItTrackFrontendApplicationService, PinItTrackFrontendServicesAccessor } from '@pit/frontend-shared';

@Component({
    selector: 'pin-it-track-web-app-breadcrumb',
    templateUrl: './pin.it.track.web.app.breadcrumb.component.html',
    styleUrls: ['./pin.it.track.web.app.breadcrumb.component.scss']
})
export class PinItTrackWebAppBreadcrumbComponent extends BaseComponent {

    constructor(private readonly servicesAccessor: PinItTrackFrontendServicesAccessor) {
        super((servicesAccessor.coreServicesAccessor.applicationService as any) as ApplicationService);

        this.applicationServiceExt = this.servicesAccessor.coreServicesAccessor.applicationService;
    }

    public readonly applicationServiceExt: IPinItTrackFrontendApplicationService = null;

    public readonly menuItemHome: any = {
        icon: 'fa fa-lg fa-home',
        skipLocationChange: true,
        link: '/home'
    };

    public async onItemClickAsync(event: any): Promise<void> {
        this.servicesAccessor.eventService.sendEvent('navigate', event.item.link);
    }

    public async onShortcutClickAsync(path: string): Promise<void> {
        this.servicesAccessor.eventService.sendEvent('navigate', path);
    }

}
